// components
import GridPageAbstract from '../../abstract/GridPageAbstract';
import { mergeHeadWithStorage } from '../../../utils/gridHeadStorage';
import { getModifiedBy } from '../../../utils/cells';

export default class GatewayApisPage extends GridPageAbstract {
    constructor(props) {
        super(props);
        this.Name = 'publicGatewayApis';
        this.Server = this.props.context.getState().server.publicGatewayApis;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['name'];
        this.showDatePicker = false;

        const defaultHead = [
            {
                id: 'name',
                label: 'name',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'modifiedReason',
                label: 'modifiedReason',
                alignRight: false,
                cell: 'BigText',
                displayGrid: true,
                disableEditor: true,
                extraRender: (value, row) => getModifiedBy(row)
            },

        ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);
        this.state = {
            ...this.state,
            head: this.Head
        };
    }
}
